var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sidebar-section", class: { collapsed: _vm.collapsed } },
    [
      _c(
        "div",
        {
          staticClass: "sidebar-section-header",
          on: {
            click: function ($event) {
              _vm.collapsed = !_vm.collapsed
            },
          },
        },
        [
          _c("span", { staticClass: "sidebar-section-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm.collapsed
            ? _c("span", { staticClass: "sidebar-section-summary" }, [
                _vm._v(_vm._s(_vm.summary || _vm.$ct("sidebar.no-info"))),
              ])
            : _vm._e(),
          _c("w-spacer"),
          _c("w-fa", {
            staticClass: "sidebar-section-chevron",
            attrs: { icon: _vm.collapsed ? "chevron-right" : "chevron-down" },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsed,
              expression: "!collapsed",
            },
          ],
          staticClass: "sidebar-section-content",
        },
        [
          _vm.block.isFieldsBlock
            ? _c("app-sidebar-fields-block", {
                key: _vm.itemVersion,
                attrs: { block: _vm.block, item: _vm.item, model: _vm.model },
                on: {
                  summary: function ($event) {
                    _vm.summary = $event
                  },
                },
              })
            : _vm.component
            ? _c(_vm.component, {
                tag: "component",
                attrs: { block: _vm.block, item: _vm.item, state: _vm.state },
                on: {
                  summary: function ($event) {
                    _vm.summary = $event
                  },
                },
              })
            : _c("div", { staticClass: "sidebar-section-unknown" }, [
                _vm._v(_vm._s(_vm.$ct("sidebar.unknown-block"))),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }